import { render } from '@testing-library/react';
import React, { useState, useEffect, Component } from 'react';

class TimeLeft extends React.Component {
    constructor(props){
        super();
        this.state={
            date: props.date,
            modifyingTimeEnded: false
        }
    }

    componentDidMount() {
        setInterval(() => {this.renderTime()}, 1000)
      }


    updateTime(){
        var now = new Date();
        var x = 172800000 - Math.abs((now  - this.state.date )); // milliseconds
        var s = Math.floor((x / 1000) % 60);
        var m = Math.floor((x / (1000 * 60)) % 60);
        var h = Math.floor((x / (1000 * 60 * 60)));
        if (x > 0) {
            this.setState({time: h + "h " + m+ " min " + s + "s restantes", modifyingTimeEnded: !this.state.modifyingTimeEnded}); 
            this.props.parentCallback(true)
        }
        else{
            this.props.parentCallback(false)
        }
    }

    async renderTime(){
        this.updateTime()
    }

    render(){
        return (
            <div style={{marginTop:20}}>
                <h4 style={{ fontSize:"0.7rem"}}>Vous avez 48h pour modifier vos préférences</h4>
                <p style={{ marginTop:0, fontSize:"0.6rem"}}> {this.state.time} </p>
            </div>
        );
  }
}

export default TimeLeft;

